import React from 'react'
import PropTypes from 'prop-types'
import DatePickerTitleCell from '#components/m/DatePicker/Parts/DatePickerTitleCell'
import ArrowLeft from '#components/svg/icons/ArrowLeft'

function DatePickerHeader({onLeftClick, onRightClick, date}) {
  return (
    <div className="date-picker-title">
      <div
        role="button"
        className="date-picker-previous-month"
        tabIndex={0}
        onKeyDown={undefined}
        onClick={onLeftClick}
      >
        <ArrowLeft />
      </div>
      <DatePickerTitleCell date={date} />
      <div role="button" className="date-picker-next-month" tabIndex={0} onKeyDown={undefined} onClick={onRightClick}>
        <ArrowLeft />
      </div>
    </div>
  )
}

DatePickerHeader.propTypes = {
  onLeftClick: PropTypes.func,
  onRightClick: PropTypes.func,
  date: PropTypes.instanceOf(Date),
}

export default DatePickerHeader
